const OPEN_MODAL = 'sales-editor/modal/OPEN_MODAL';
export const openModal = () => ({ type: OPEN_MODAL });

export const CLOSE_MODAL = 'sales-editor/modal/CLOSE_MODAL';
export const closeModal = () => ({ type: CLOSE_MODAL });

function freezeBody() {
  const { body } = global.document;
  const classNames = body.className;
  const matchData = classNames.match(/(\s|^)tes-modal--opened-container(\s|$)/);
  if (matchData) return;
  body.className = `${classNames} tes-modal--opened-container`;
}

function unfreezeBody() {
  const { body } = global.document;
  body.className = body.className.replace(/(\s|^)tes-modal--opened-container(\s|$)/, '$1');
}

const initialState = { show: false };

export default function reducer(action, state = initialState) {
  switch (action.type) {
    case OPEN_MODAL:
      freezeBody();
      return { show: true };
    case CLOSE_MODAL:
      unfreezeBody();
      return { show: false };
    default:
      return state;
  }
}
